import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export interface TrailingNodeOptions {
    node: string;
    notAfter: string[];
}

/**
 * Всегда держит пустой paragraph в конце документа,
 * чтобы можно было поставить курсор после блочных узлов (картинок и т.п.).
 */
export const EditorTrailingNode = Extension.create<TrailingNodeOptions>({
    name: 'trailingNode',

    addOptions() {
        return {
            node: 'paragraph',
            notAfter: ['paragraph'],
        };
    },

    addProseMirrorPlugins() {
        const key = new PluginKey(this.name);
        const disabledNodes = Object.entries(this.editor.schema.nodes)
            .map(([, value]) => value)
            .filter((node) => this.options.notAfter.includes(node.name));

        return [
            new Plugin({
                key,
                appendTransaction: (_transactions, _oldState, state) => {
                    const shouldInsertNodeAtEnd = key.getState(state);
                    const endPosition = state.doc.content.size;
                    const type = state.schema.nodes[this.options.node];

                    if (!shouldInsertNodeAtEnd || !type) {
                        return null;
                    }

                    return state.tr.insert(endPosition, type.create());
                },
                state: {
                    init: (_, state) => {
                        const lastNode = state.tr.doc.lastChild;
                        return lastNode ? !disabledNodes.includes(lastNode.type) : false;
                    },
                    apply: (tr, value) => {
                        if (!tr.docChanged) {
                            return value;
                        }
                        const lastNode = tr.doc.lastChild;
                        return lastNode ? !disabledNodes.includes(lastNode.type) : false;
                    },
                },
            }),
        ];
    },
});
